module.exports = __webpack_public_path__ + "media/images/rank-6ae4499ddf613fd3beac0b279d41af84.png";